import { asyncToGenerator as _asyncToGenerator } from '../../_virtual/_rollupPluginBabelHelpers.js';
import { getAuthIntegrations } from './config.js';
import { AuthIntegrationAction, AuthIntegrationEvent } from './constants.js';
import jwtAuth$1 from './integrations/jwt/index.js';

var integrations = getAuthIntegrations(); // action types

var NAMESPACE = "AUTH";
var AUTHENTICATE = "".concat(NAMESPACE, "/AUTHENTICATE");
var DEAUTHENTICATE = "".concat(NAMESPACE, "/DEAUTHENTICATE");
/**
 * Action creator for authenticating access to the app (using JWT tokens)
 * @param {string} accessToken JWT access token to be stored
 * @param {string} refreshToken JWT refresh token to be stored
 */

var authenticate = function authenticate() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  return /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(dispatch) {
      var integration, authEvent, result, successEvent;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              integration = integrations.getDefault();

              if (integration) {
                _context.next = 3;
                break;
              }

              return _context.abrupt("return");

            case 3:
              authEvent = integration.findEvent(AuthIntegrationEvent.Authenticate);

              if (authEvent) {
                _context.next = 6;
                break;
              }

              return _context.abrupt("return");

            case 6:
              _context.next = 8;
              return authEvent.apply(void 0, [dispatch].concat(args));

            case 8:
              _context.t0 = _context.sent;

              if (_context.t0) {
                _context.next = 11;
                break;
              }

              _context.t0 = {};

            case 11:
              result = _context.t0;
              dispatch({
                type: AUTHENTICATE,
                result: result
              });
              successEvent = integration.findEvent(AuthIntegrationEvent.Authenticated);
              if (successEvent) successEvent(dispatch, result);

            case 15:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }();
};
/**
 * Action creator for deauthenticating access to the app (using JWT tokens)
 */


var deauthenticate = function deauthenticate() {
  for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    args[_key2] = arguments[_key2];
  }

  return /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(dispatch) {
      var integration, deauthEvent, result, successEvent;
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              integration = integrations.getDefault();

              if (integration) {
                _context2.next = 3;
                break;
              }

              return _context2.abrupt("return");

            case 3:
              deauthEvent = integration.findEvent(AuthIntegrationEvent.Deauthenticate);

              if (deauthEvent) {
                _context2.next = 6;
                break;
              }

              return _context2.abrupt("return");

            case 6:
              _context2.next = 8;
              return deauthEvent.apply(void 0, [dispatch].concat(args));

            case 8:
              _context2.t0 = _context2.sent;

              if (_context2.t0) {
                _context2.next = 11;
                break;
              }

              _context2.t0 = {};

            case 11:
              result = _context2.t0;
              dispatch({
                type: DEAUTHENTICATE,
                result: result
              });
              successEvent = integration.findEvent(AuthIntegrationEvent.Deauthenticated);
              if (successEvent) successEvent(dispatch, result);

            case 15:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function (_x2) {
      return _ref2.apply(this, arguments);
    };
  }();
};
/**
 * Action creator for ensuring the current JWT token is still valid and refreshing if required
 * @deprecated use AuthActions.refresh instead
 * @param {boolean} invalidate Whether the existing token should be invalidated, if true a new JWT token will always be requested, otherwise a new token will only be obtained if the current one has expired, default true
 * @returns {string} Returns a promise that when resolved gives the current JWT token
 */


var refreshJwt = function refreshJwt() {
  var invalidate = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
  return function (dispatch) {
    var refreshAction = jwtAuth$1.findAction(AuthIntegrationAction.RefreshToken);
    if (!refreshAction) return;
    return refreshAction(dispatch, authenticate, deauthenticate, invalidate);
  };
};
/**
 * Action creator for re-authenticating access to the app from a previously authenticated session (using JWT tokens)
 * @param {boolean} invalidate Whether any existing token should be invalidated, if true a new JWT token will always be requested, otherwise a new token will only be obtained if the current one has expired, default false
 * @returns {object} `reauthenticateResult` The result of JWT reauthentication { success, accessToken, error }
 */


var reauthenticate = function reauthenticate() {
  for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
    args[_key3] = arguments[_key3];
  }

  return /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(dispatch) {
      var integration, restoreEvent, restoreSuccess, reauthenticateEvent;
      return regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              integration = integrations.getDefault();

              if (integration) {
                _context3.next = 3;
                break;
              }

              return _context3.abrupt("return");

            case 3:
              // legacy support for OnRestore event
              restoreEvent = integration.findEvent(AuthIntegrationEvent.Restore);

              if (!restoreEvent) {
                _context3.next = 10;
                break;
              }

              _context3.next = 7;
              return restoreEvent(dispatch, authenticate, deauthenticate);

            case 7:
              restoreSuccess = _context3.sent;

              if (restoreSuccess) {
                _context3.next = 10;
                break;
              }

              return _context3.abrupt("return");

            case 10:
              reauthenticateEvent = integration.findEvent(AuthIntegrationEvent.Reauthenticate);

              if (reauthenticateEvent) {
                _context3.next = 13;
                break;
              }

              return _context3.abrupt("return");

            case 13:
              _context3.next = 15;
              return reauthenticateEvent.apply(void 0, [dispatch, authenticate, deauthenticate].concat(args));

            case 15:
              return _context3.abrupt("return", _context3.sent);

            case 16:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }));

    return function (_x3) {
      return _ref3.apply(this, arguments);
    };
  }();
};
/**
 * Action creator for refreshing a currently authenticated session (using JWT tokens)
 * @param {boolean} invalidate Whether the existing token should be invalidated, if true a new JWT token will always be requested, otherwise a new token will only be obtained if the current one has expired, default true
 * @returns {object} `refreshResult` The result of refreshing JWT tokens { success, accessToken, error }
 */


var refresh = function refresh() {
  for (var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
    args[_key4] = arguments[_key4];
  }

  return /*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(dispatch) {
      var integration, refreshEvent;
      return regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              integration = integrations.getDefault();

              if (integration) {
                _context4.next = 3;
                break;
              }

              return _context4.abrupt("return");

            case 3:
              refreshEvent = integration.findEvent(AuthIntegrationEvent.Refresh);

              if (refreshEvent) {
                _context4.next = 6;
                break;
              }

              return _context4.abrupt("return");

            case 6:
              _context4.next = 8;
              return refreshEvent.apply(void 0, [dispatch, authenticate, deauthenticate].concat(args));

            case 8:
              return _context4.abrupt("return", _context4.sent);

            case 9:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4);
    }));

    return function (_x4) {
      return _ref4.apply(this, arguments);
    };
  }();
};

export { AUTHENTICATE, DEAUTHENTICATE, authenticate, deauthenticate, reauthenticate, refresh, refreshJwt };
